import ExcelJS from "exceljs";

function formatDate(value) {
    if (!value) {
        return null;
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return date;
}

function normalizeNumber(value) {
    if (
        value === null ||
        value === undefined ||
        value === ""
    ) {
        return null;
    }

    const number = Number(value);

    return Number.isNaN(number)
        ? value
        : number;
}

export async function gerarExcelEDownload(lista = []) {
    if (!Array.isArray(lista)) {
        throw new TypeError(
            "A lista de produtos precisa ser um array."
        );
    }

    const workbook =
        new ExcelJS.Workbook();

    workbook.creator = "Pitaya Pay";
    workbook.created = new Date();

    const worksheet =
        workbook.addWorksheet(
            "Produtos Fornecedores",
            {
                views: [
                    {
                        state: "frozen",
                        ySplit: 1,
                    },
                ],
            }
        );

    /*
     * As colunas incluem:
     * - dados comuns de JewelryBase;
     * - dados específicos de cada modelo;
     * - campos de auditoria.
     *
     * Campos inexistentes em determinada categoria ficam vazios.
     */
    worksheet.columns = [
        {
            header: "Tipo",
            key: "tipo",
            width: 18,
        },
        {
            header: "ID Banco",
            key: "id",
            width: 12,
        },
        {
            header: "ID Produto",
            key: "id_produto",
            width: 20,
        },
        {
            header: "Código Fornecedor",
            key: "id_supplier",
            width: 22,
        },
        {
            header: "Fornecedor",
            key: "supplier",
            width: 30,
        },
        {
            header: "ID Fornecedor",
            key: "supplier_id",
            width: 15,
        },

        {
            header: "Cor",
            key: "color",
            width: 20,
        },
        {
            header: "ID Cor",
            key: "color_id",
            width: 12,
        },
        {
            header: "Estilo",
            key: "style",
            width: 22,
        },
        {
            header: "ID Estilo",
            key: "style_id",
            width: 12,
        },
        {
            header: "Detalhamento Base",
            key: "detailing",
            width: 30,
        },

        {
            header: "Estoque Inicial",
            key: "initial_inventory",
            width: 16,
        },
        {
            header: "Estoque Disponível",
            key: "quantity_available",
            width: 19,
        },

        {
            header: "Preço de Custo",
            key: "cost_price",
            width: 17,
            style: {
                numFmt:
                    '"R$" #,##0.00',
            },
        },
        {
            header: "Preço Sugerido",
            key: "suggested_price",
            width: 18,
            style: {
                numFmt:
                    '"R$" #,##0.00',
            },
        },
        {
            header: "Preço Praticado",
            key: "charged_price",
            width: 19,
            style: {
                numFmt:
                    '"R$" #,##0.00',
            },
        },
        {
            header: "Data da Compra",
            key: "purchase_date",
            width: 17,
            style: {
                numFmt: "dd/mm/yyyy",
            },
        },

        {
            header: "Peso",
            key: "weight",
            width: 12,
            style: {
                numFmt: "0.00",
            },
        },
        {
            header: "Banho",
            key: "plated",
            width: 12,
            style: {
                numFmt: "0.00",
            },
        },
        {
            header: "Ródio Branco",
            key: "rodio_b",
            width: 15,
            style: {
                numFmt: "0.00",
            },
        },
        {
            header: "Ródio Negro",
            key: "rodio_n",
            width: 15,
            style: {
                numFmt: "0.00",
            },
        },

        /*
         * Campos específicos de Anéis
         */
        {
            header: "Cor da Pedra",
            key: "cor_pedra",
            width: 20,
        },
        {
            header: "Tamanho do Anel",
            key: "tamanho_anel",
            width: 17,
        },

        /*
         * Campo tamanho utilizado por outros modelos.
         */
        {
            header: "Tamanho",
            key: "tamanho",
            width: 15,
        },

        /*
         * Campos específicos de Corrente
         */
        {
            header: "Tipo",
            key: "tipo_produto",
            width: 22,
        },
        {
            header: "Fio",
            key: "fio",
            width: 20,
        },
        {
            header: "Tipo Pingente",
            key: "tipo_pingente",
            width: 22,
        },
        {
            header: "Detalhe Pingente",
            key: "detalhe_pingente",
            width: 25,
        },
        {
            header: "Modelo",
            key: "modelo",
            width: 22,
        },
        {
            header: "Tamanho Medalha",
            key: "tamanho_medalha",
            width: 20,
        },
        {
            header: "Detalhe Medalha",
            key: "detalhe_medalha",
            width: 25,
        },

        /*
         * Campos específicos de Pulseira
         */
        {
            header: "Categoria",
            key: "categoria",
            width: 22,
        },
        {
            header: "Espessura",
            key: "espessura",
            width: 17,
        },

        /*
         * Campos específicos de Brinco
         */
        {
            header: "Cartela",
            key: "cartela",
            width: 17,
        },
        {
            header: "Característica",
            key: "caracteristica",
            width: 25,
        },
        {
            header: "Fecho",
            key: "fecho",
            width: 20,
        },

        /*
         * Campos específicos de Conjunto
         */
        {
            header: "Composição",
            key: "composicao",
            width: 30,
        },

        /*
         * Campos com nomes semelhantes utilizados
         * pelos diferentes modelos.
         */
        {
            header: "Detalhamento",
            key: "detalhamento",
            width: 35,
        },

        /*
         * Campos gerais e auditoria
         */
        {
            header: "Ativo",
            key: "ativo",
            width: 12,
        },
        {
            header: "Observação",
            key: "observacao",
            width: 40,
        },
        {
            header: "Criado em",
            key: "criados",
            width: 20,
            style: {
                numFmt:
                    "dd/mm/yyyy hh:mm",
            },
        },
        {
            header: "Atualizado em",
            key: "modificado",
            width: 20,
            style: {
                numFmt:
                    "dd/mm/yyyy hh:mm",
            },
        },
    ];

    lista.forEach((item) => {
        /*
         * O backend utiliza "tipo" tanto para a categoria geral,
         * adicionada manualmente, quanto alguns models possuem
         * um campo chamado "tipo".
         *
         * Para não perder nenhuma informação:
         * - tipo representa Aneis, Corrente, Brinco etc.;
         * - tipo_produto representa o tipo específico do model.
         *
         * Para isso, o backend deve retornar o campo específico
         * como tipo_produto, conforme explicado abaixo.
         */
        const row = worksheet.addRow({
            tipo:
                item.tipo_modelo ??
                item.tipo,

            id: item.id ?? null,
            id_produto:
                item.id_produto ?? null,

            id_supplier:
                item.id_supplier ?? null,

            supplier:
                item.supplier ?? null,

            supplier_id:
                item.supplier_id ?? null,

            color:
                item.color ?? null,

            color_id:
                item.color_id ?? null,

            style:
                item.style ?? null,

            style_id:
                item.style_id ?? null,

            detailing:
                item.detailing ?? null,

            initial_inventory:
                normalizeNumber(
                    item.initial_inventory
                ),

            quantity_available:
                normalizeNumber(
                    item.quantity_available
                ),

            cost_price:
                normalizeNumber(
                    item.cost_price
                ),

            suggested_price:
                normalizeNumber(
                    item.suggested_price
                ),

            charged_price:
                normalizeNumber(
                    item.charged_price
                ),

            purchase_date:
                formatDate(
                    item.purchase_date
                ),

            weight:
                normalizeNumber(
                    item.weight
                ),

            plated:
                normalizeNumber(
                    item.plated
                ),

            rodio_b:
                normalizeNumber(
                    item.rodio_b
                ),

            rodio_n:
                normalizeNumber(
                    item.rodio_n
                ),

            cor_pedra:
                item.cor_pedra ?? null,

            tamanho_anel:
                item.tipo_modelo ===
                    "Aneis" ||
                item.tipo === "Aneis"
                    ? normalizeNumber(
                          item.tamanho
                      )
                    : null,

            tamanho:
                item.tipo_modelo ===
                    "Aneis" ||
                item.tipo === "Aneis"
                    ? null
                    : item.tamanho ??
                      null,

            tipo_produto:
                item.tipo_produto ??
                null,

            fio:
                item.fio ?? null,

            tipo_pingente:
                item.tipo_pingente ??
                null,

            detalhe_pingente:
                item.detalhe_pingente ??
                null,

            modelo:
                item.modelo ?? null,

            tamanho_medalha:
                item.tamanho_medalha ??
                null,

            detalhe_medalha:
                item.detalhe_medalha ??
                null,

            categoria:
                item.categoria ?? null,

            espessura:
                item.espessura ?? null,

            cartela:
                item.cartela ?? null,

            caracteristica:
                item.caracteristica ??
                null,

            fecho:
                item.fecho ?? null,

            composicao:
                item.composicao ?? null,

            detalhamento:
                item.detalhamento ?? null,

            ativo:
                item.ativo === true
                    ? "Sim"
                    : item.ativo === false
                      ? "Não"
                      : null,

            observacao:
                item.observacao ?? null,

            criados:
                formatDate(
                    item.criados
                ),

            modificado:
                formatDate(
                    item.modificado
                ),
        });

        row.alignment = {
            vertical: "middle",
            wrapText: true,
        };
    });

    /*
     * Estilização do cabeçalho.
     */
    const headerRow =
        worksheet.getRow(1);

    headerRow.font = {
        bold: true,
    };

    headerRow.alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
    };

    headerRow.height = 32;

    /*
     * Ativa filtros no cabeçalho.
     */
    if (
        worksheet.columnCount > 0
    ) {
        worksheet.autoFilter = {
            from: {
                row: 1,
                column: 1,
            },
            to: {
                row: 1,
                column:
                    worksheet.columnCount,
            },
        };
    }

    /*
     * Mantém códigos como texto, evitando:
     * - remoção de zeros à esquerda;
     * - notação científica;
     * - conversões automáticas do Excel.
     */
    [
        "id_produto",
        "id_supplier",
    ].forEach((columnKey) => {
        const column =
            worksheet.getColumn(
                columnKey
            );

        column.numFmt = "@";
    });

    const buffer =
        await workbook.xlsx.writeBuffer();

    const blob = new Blob(
        [buffer],
        {
            type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }
    );

    const url =
        URL.createObjectURL(blob);

    const anchor =
        document.createElement("a");

    anchor.href = url;
    anchor.download =
        "produtos_fornecedores.xlsx";

    document.body.appendChild(
        anchor
    );

    anchor.click();
    anchor.remove();

    URL.revokeObjectURL(url);
}